import RaceMixins from '../../../../../components/_mixins/races'
import config from '../../../../../lib/config'
const {BASE_IMAGES: reImagePath} = config
import {alert, getQS} from '../../../../../lib/utils'
const qs = getQS() || {}
const noHold = !!qs.nohold

export default {
  name: 'timeslot-group',
  props: {
    time: {default: null}
  },
  mixins: [RaceMixins],
  components: {},
  data() {
    return {
      racerImageUri: reImagePath + '/place.png',
      item: {}
    }
  },
  created() {
    this.item = this.retrievedTimeslot(this.time)
  },
  computed: {
    racersCount: {
      get() {
        return this.item.racers || 0
      },
      set(value) {
        this.setTimeslotData({time: this.time, key: 'racers', value: value})
      }
    },
    tMemberCount: {
      get() {
        return this.item.tMembers || 0
      },
      set(value) {
        this.setTimeslotData({time: this.time, key: 'tMembers', value: value})
      }
    },
    racerLimit() {
      const item = this.item
      const playerLimit = this.maxSelectableRaces || 0
      return Math.min(item.karts, playerLimit)
    },
    tMemberLimit() {
      return Math.min(this.racersCount, this.totalMembersNotSlotted + this.tMemberCount)
    }
  },
  methods: {
    removeMe() {
      this.removeTimeslot(this.item)
      this.updateRacersRacesMatrixOnSelection()
    },
    async addRacer() {
      if (this.item.processing) {
        alert('This selected slot is being processed.')
        return false
      }
      const oldCount = this.racersCount
      const count = this.racersCount = oldCount + 1
      this.updateRacersRacesMatrixOnSelection()

      const holds = await this.holdSlot(this.item, count)
      if (noHold || holds) {
        this.racersCount = count
        _.forOwn(holds , (hold, time) => {
            this.setTimeslotData({time, key: 'hold', value: hold})
        })
      } else {
        this.racersCount = oldCount
      }

      this.updateRacersRacesMatrixOnSelection()
    },
    async subRacer() {
      if (this.item.processing) {
        alert('This selected slot is being processed.')
        return false
      }
      const oldCount = this.racersCount
      const count = this.racersCount = Math.max(0, oldCount - 1)

      if (count === oldCount) {
        return
      }

      this.updateRacersRacesMatrixOnSelection()

      if (this.tMemberCount > count) {
        this.tMemberCount = count
      }

      if (count === 0) {
        await this.unholdSlot(this.item)
        this.racersCount = count
      } else {
        const holds = await this.holdSlot(this.item, count)
        if (noHold || holds) {
          this.racersCount = count
          _.forOwn(holds , (hold, time) => {
              this.setTimeslotData({time, key: 'hold', value: hold})
          })
        } else {
          this.racersCount = oldCount
        }
      }
      this.updateRacersRacesMatrixOnSelection()
    },
    addTMember() {
      ++this.tMemberCount
    },
    subTMember() {
      --this.tMemberCount
    },
  }
}
